import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useUpdateMarkTemplate = () => {
    const additional = useQueryRequestParams();
    return useMutation({
        mutationFn: (body) => axios.post(markUrl('mark-templates/update/'), body, additional)
    });
};
export default useUpdateMarkTemplate;
